export default "__VITE_ASSET__BHQYEYqz__"